import { extractRepeatOptionFromCron, getScheduleNamePlaceholder } from './functions/charging-schedule.functions'
import { ChargingScheduleModel } from './models'
import { RepeatOptions, ScheduleCounter } from './types'

export const countRecurringAndOneTimeSchedules = (chargingSchedules: ChargingScheduleModel[]): ScheduleCounter => {
  let weekly = 0
  let daily = 0
  let oneTime = 0

  chargingSchedules.forEach(s => {
    if (s.schedule && 'cron' in s.schedule) {
      const repeat = extractRepeatOptionFromCron(s.schedule.cron)
      if (repeat === RepeatOptions.daily) {
        daily++
      } else {
        weekly++
      }
    } else {
      oneTime++
    }
  })

  return { weekly, daily, oneTime }
}

export const scheduleListWithPlaceholderName = (
  chargingSchedules: ChargingScheduleModel[],
  t: (key: string) => string
): (ChargingScheduleModel & { temporaryScheduleName: string })[] => {
  let oneTimeCounter = 0
  let dailyCounter = 0
  let weeklyCounter = 0

  return (chargingSchedules ?? []).map(schedule => {
    let repeatType: RepeatOptions
    if (schedule.schedule && 'cron' in schedule.schedule) {
      repeatType = extractRepeatOptionFromCron(schedule.schedule.cron)
    } else {
      repeatType = RepeatOptions.doNotRepeat
    }

    let counter = 0
    if (repeatType === RepeatOptions.doNotRepeat) {
      oneTimeCounter++
      counter = oneTimeCounter
    } else if (repeatType === RepeatOptions.daily) {
      dailyCounter++
      counter = dailyCounter
    } else {
      weeklyCounter++
      counter = weeklyCounter
    }

    return {
      ...schedule,
      temporaryScheduleName: `${t(getScheduleNamePlaceholder(repeatType))} ${counter}`,
    }
  })
}
